import { render, staticRenderFns } from "./ClubSelect.vue?vue&type=template&id=1e61008d&scoped=true"
import script from "./ClubSelect.vue?vue&type=script&lang=js"
export * from "./ClubSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e61008d",
  null
  
)

export default component.exports